import { defaultOptions } from '../utilities';
import { defaultUniversalRender } from '../render/holy-render';
var HolyStars = (function () {
    function HolyStars(optionsInput, render) {
        if (render === void 0) { render = defaultUniversalRender; }
        this.optionsInput = optionsInput;
        this.render = render;
        if (!optionsInput.el) {
            throw new Error("Element is ".concat(optionsInput.el));
        }
        if (typeof optionsInput.el === 'string') {
            if (document) {
                var target = document.querySelector(optionsInput.el);
                if (target !== null) {
                    optionsInput.el = target;
                }
                else {
                    throw new Error("Element ".concat(optionsInput.el, " not found on page"));
                }
            }
            else {
                throw new Error("document not found, cannot find element: ".concat(optionsInput.el));
            }
        }
        if (typeof optionsInput.rate === 'string') {
            var target = parseFloat(optionsInput.rate);
            if (!isNaN(target)) {
                optionsInput.rate = target;
            }
            else {
                throw new Error("Value ".concat(optionsInput.rate, " for rating not supported"));
            }
        }
        this.options = Object.assign({}, defaultOptions(), optionsInput, {
            el: optionsInput.el,
            rate: optionsInput.rate,
        });
        this.render.mount(this.options);
    }
    HolyStars.prototype.update = function (options) {
        if (options) {
            this.options = Object.assign({}, this.options, options);
        }
        this.render.mount(this.options);
    };
    return HolyStars;
}());
export { HolyStars };
//# sourceMappingURL=holy-stars.js.map